import { render } from "./AboutVideo.vue?vue&type=template&id=7ec53194&scoped=true"
import script from "./AboutVideo.vue?vue&type=script&lang=js"
export * from "./AboutVideo.vue?vue&type=script&lang=js"

import "./AboutVideo.vue?vue&type=style&index=0&id=7ec53194&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec53194"]])

export default __exports__